import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default {
  __name: 'StatusWizyty',
  setup(__props) {

console.log("sw");

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", null, "testestest"))
}
}

}